(function () {
  'use strict';

  var FALLBACK_COORDS = {
    '28806':[35.5318,-82.6050], '65616':[36.6378,-93.2676], '29418':[32.8754,-80.0167],
    '33306':[26.1689,-80.1179], '32117':[29.2187,-81.1117], '36535':[30.3788,-87.6830],
    '08527':[40.1609,-74.4189], '17602':[40.0270,-76.2194], '29572':[33.7923,-78.7695],
    '33401':[26.7247,-80.0848], '31322':[32.1351,-81.2446], '19464':[40.2366,-75.5713],
    '19971':[38.7178,-75.1133], '78666':[29.8267,-97.9806], '43074':[40.2709,-82.9265],
    '07753':[40.2250,-74.0947]
  };

  function toArray(list) { return Array.prototype.slice.call(list || []); }

  function loadLeaflet() {
    if (window.L && window.L.map) return Promise.resolve(window.L);
    if (window.__sslLeafletPromise) return window.__sslLeafletPromise;

    window.__sslLeafletPromise = new Promise(function (resolve, reject) {
      if (!document.querySelector('link[data-ssl-leaflet]')) {
        var css = document.createElement('link');
        css.rel = 'stylesheet';
        css.href = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.css';
        css.setAttribute('data-ssl-leaflet', '');
        document.head.appendChild(css);
      }

      var existing = document.querySelector('script[data-ssl-leaflet]');
      if (existing) {
        existing.addEventListener('load', function () { resolve(window.L); }, { once: true });
        existing.addEventListener('error', reject, { once: true });
        return;
      }

      var script = document.createElement('script');
      script.src = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.js';
      script.defer = true;
      script.setAttribute('data-ssl-leaflet', '');
      script.onload = function () { resolve(window.L); };
      script.onerror = reject;
      document.head.appendChild(script);
    });

    return window.__sslLeafletPromise;
  }

  function getCoords(card) {
    var lat = parseFloat(card.getAttribute('data-lat'));
    var lng = parseFloat(card.getAttribute('data-lng'));
    if (isFinite(lat) && isFinite(lng)) return [lat, lng];
    var text = card.getAttribute('data-map') || '';
    var match = text.match(/\b\d{5}\b/);
    return match && FALLBACK_COORDS[match[0]] ? FALLBACK_COORDS[match[0]] : null;
  }

  function initLocator(root) {
    if (!root || root.getAttribute('data-native-map-ready') === 'true') return;
    root.setAttribute('data-native-map-ready', 'true');

    var search = root.querySelector('.ssl__search');
    var state = root.querySelector('.ssl__state');
    var cards = toArray(root.querySelectorAll('[data-store]'));
    var count = root.querySelector('[data-count]');
    var empty = root.querySelector('[data-empty]');
    var clear = root.querySelector('[data-clear]');
    var mapCanvas = root.querySelector('[data-map-canvas]');
    var mapLabel = root.querySelector('[data-map-label]');
    var allButton = root.querySelector('[data-map-all]');
    var defaultLabel = mapLabel ? mapLabel.textContent.trim() : 'All Spring Step Shoes locations';

    if (!search || !state || !cards.length || !mapCanvas) return;

    while (state.options.length > 1) state.remove(1);
    var states = {};
    cards.forEach(function (card) {
      var value = (card.getAttribute('data-state') || '').trim();
      if (value) states[value] = true;
    });
    Object.keys(states).sort().forEach(function (value) {
      var option = document.createElement('option');
      option.value = value;
      option.textContent = value;
      state.appendChild(option);
    });

    loadLeaflet().then(function (L) {
      if (!L || !L.map || root.__sslMap) return;

      var map = L.map(mapCanvas, { scrollWheelZoom: false, zoomControl: true, attributionControl: true });
      root.__sslMap = map;
      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        maxZoom: 19,
        attribution: '&copy; OpenStreetMap contributors'
      }).addTo(map);

      var entries = [];

      function makeIcon(active) {
        return L.divIcon({
          className: 'ssl-map-marker' + (active ? ' is-active' : ''),
          html: '<span class="ssl-map-pin" aria-hidden="true"></span>',
          iconSize: [24, 24],
          iconAnchor: [12, 12],
          popupAnchor: [0, -14]
        });
      }

      function popupNode(card) {
        var wrap = document.createElement('div');
        wrap.className = 'ssl-map-popup';
        var title = document.createElement('strong');
        title.textContent = (card.querySelector('h2') || card.querySelector('.ssl__city')).textContent.trim();
        var city = document.createElement('span');
        city.textContent = (card.querySelector('.ssl__city') || {}).textContent || '';
        wrap.appendChild(title);
        wrap.appendChild(document.createElement('br'));
        wrap.appendChild(city);
        return wrap;
      }

      cards.forEach(function (card) {
        var coords = getCoords(card);
        if (!coords) return;
        var marker = L.marker(coords, { icon: makeIcon(false), keyboard: true }).addTo(map);
        marker.bindPopup(popupNode(card));
        marker.on('click', function () {
          selectStore(card, false, false);
        });
        entries.push({ card: card, marker: marker, coords: coords });
      });

      function visibleEntries() {
        return entries.filter(function (entry) { return !entry.card.hidden && entry.card.style.display !== 'none'; });
      }

      function syncMarkerVisibility() {
        entries.forEach(function (entry) {
          var visible = !entry.card.hidden && entry.card.style.display !== 'none';
          if (visible && !map.hasLayer(entry.marker)) entry.marker.addTo(map);
          if (!visible && map.hasLayer(entry.marker)) map.removeLayer(entry.marker);
        });
      }

      function setActive(entry) {
        cards.forEach(function (card) { card.classList.remove('is-active'); });
        entries.forEach(function (item) { item.marker.setIcon(makeIcon(item === entry)); });
        if (entry) entry.card.classList.add('is-active');
      }

      function fitEntries(list) {
        if (!list.length) return;
        if (list.length === 1) {
          map.setView(list[0].coords, 14, { animate: true });
          return;
        }
        var bounds = L.latLngBounds(list.map(function (entry) { return entry.coords; }));
        map.fitBounds(bounds, { padding: [32, 32], maxZoom: 8, animate: true });
      }

      function showAll() {
        setActive(null);
        if (mapLabel) mapLabel.textContent = defaultLabel;
        fitEntries(visibleEntries().length ? visibleEntries() : entries);
        setTimeout(function () { map.invalidateSize(); }, 60);
      }

      function selectStore(card, scrollToMap, openPopup) {
        var entry = entries.filter(function (item) { return item.card === card; })[0];
        if (!entry) return;
        setActive(entry);
        var heading = card.querySelector('h2');
        var city = card.querySelector('.ssl__city');
        if (mapLabel) mapLabel.textContent = heading && heading.textContent.trim() ? heading.textContent.trim() : (city ? city.textContent.trim() : card.getAttribute('data-map'));
        map.setView(entry.coords, 15, { animate: true });
        if (openPopup !== false) entry.marker.openPopup();
        setTimeout(function () { map.invalidateSize(); }, 60);
        if (scrollToMap && window.matchMedia && window.matchMedia('(max-width:1100px)').matches) {
          var mapCol = root.querySelector('.ssl__map-col');
          if (mapCol && mapCol.scrollIntoView) mapCol.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }

      function applyFilter() {
        var term = (search.value || '').trim().toLowerCase();
        var selectedState = state.value || '';
        var visibleCards = [];

        cards.forEach(function (card) {
          var haystack = (card.getAttribute('data-search') || '').toLowerCase();
          var cardState = card.getAttribute('data-state') || '';
          var show = (!term || haystack.indexOf(term) !== -1) && (!selectedState || cardState === selectedState);
          card.hidden = !show;
          card.style.display = show ? '' : 'none';
          if (show) visibleCards.push(card);
        });

        if (count) count.textContent = String(visibleCards.length);
        if (empty) {
          empty.hidden = visibleCards.length !== 0;
          empty.style.display = visibleCards.length === 0 ? '' : 'none';
        }

        syncMarkerVisibility();
        var visible = visibleEntries();
        if (visible.length === 1) selectStore(visible[0].card, false, false);
        else if (visible.length > 1) {
          setActive(null);
          if (mapLabel) mapLabel.textContent = visible.length === entries.length ? defaultLabel : visible.length + ' matching locations';
          fitEntries(visible);
        }
      }

      search.addEventListener('input', applyFilter);
      search.addEventListener('search', applyFilter);
      state.addEventListener('change', applyFilter);

      if (clear) clear.addEventListener('click', function () {
        search.value = '';
        state.value = '';
        applyFilter();
        search.focus();
      });

      if (allButton) allButton.addEventListener('click', function () {
        search.value = '';
        state.value = '';
        applyFilter();
        showAll();
      });

      cards.forEach(function (card) {
        var trigger = card.querySelector('[data-map-trigger]');
        if (trigger) trigger.addEventListener('click', function (event) {
          event.preventDefault();
          selectStore(card, true, true);
        });
      });

      applyFilter();
      showAll();
      setTimeout(function () { map.invalidateSize(); showAll(); }, 180);
    }).catch(function () {
      mapCanvas.innerHTML = '<p class="ssl__map-error">Interactive map could not load. Please use the Directions links for a location.</p>';
    });
  }

  function initAll(scope) {
    var context = scope && scope.querySelectorAll ? scope : document;
    toArray(context.querySelectorAll('[id^="StoreLocator-"]')).forEach(initLocator);
    if (context.matches && context.matches('[id^="StoreLocator-"]')) initLocator(context);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  else initAll(document);
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();
